module.exports = __webpack_public_path__ + "img/m2.1f74b7af.jpg";